import { useRouteError } from "react-router-dom";

export default function AppError() {
    const error = useRouteError() as { message?: string; statusText?: string };
    const message = error?.message || error?.statusText || "An unexpected error occurred.";

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                gap: "16px",
                fontFamily: "'Montserrat', 'Segoe UI', sans-serif",
                background: "#F5F7FA",
                color: "#1F2937",
                padding: "32px"
            }}
        >
            <img src="/dyn_logo-primary.png" alt="Dynasty Financial Partners" height="56" style={{ marginBottom: "8px" }} />
            <h2 style={{ fontSize: "1.25rem", fontWeight: 700, margin: 0 }}>Something went wrong</h2>
            <p style={{ color: "#6B7280", fontSize: "0.9rem", margin: 0, textAlign: "center", maxWidth: "420px" }}>{message}</p>
            <button
                onClick={() => window.location.reload()}
                style={{
                    marginTop: "8px",
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "none",
                    background: "radial-gradient(109.81% 107.82% at 100.1% 90.19%, #0F6CBD 33.63%, #2D87C3 70.31%, #8DDDD8 100%)",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "0.875rem",
                    cursor: "pointer"
                }}
            >
                Reload
            </button>
        </div>
    );
}
